<template>
  <div>
    Измерение
  </div>
</template>
<script>
export default {
  name: "Measure",
};
</script>
